export default {
    props: {
        contentTemplate: {
            type: String,
            kComposite: 'content.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Content.js